import { jsx as _jsx } from "react/jsx-runtime";
import CopyField from "@iscr/xAppLib/UIelems/CopyField";
/**
 * SAP's business partner ID for the profile. Only exists once SAP has confirmed a sync (it's SAP that
 * mints it and reports it back over the webhook), and it's the identifier finance needs when
 * cross-checking a doctor in SAP itself - hence copyable rather than just displayed.
 */
export const SapBpId = ({ sap_bp_id }) => (_jsx(CopyField, { inline: true, val: sap_bp_id, title: `Copy SAP BP ID ${sap_bp_id}` }));
export const SapBpIdCell = ({ row }) => row.sap_bp_id ? _jsx(SapBpId, { sap_bp_id: row.sap_bp_id }) : _jsx("span", { className: "text-gray-400", children: "-" });
